import React from "react";
import ListFormat from '../../../Formatters/ListFormat';
import CurrencyFormat from '../../../Formatters/CurrencyFormat';
import PropTypes from 'prop-types';

export default function ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount, termLengths) {
  return {
    image: "product-landing/loan/circle1.png",
    specs: [
      {
        title: "Eligibility",
        text: `${minAge} - ${maxAge} years, depending upon term lengths`,
      },
      {
        title: "Term Lengths",
        text: <span><ListFormat numbers={termLengths.map(n => n.value)} /> years</span>,
      },
      {
        title: "Coverage amount",
        text: <span><CurrencyFormat number={minCoverageAmount} whole /> - <CurrencyFormat number={maxCoverageAmount} whole /></span>,
      },
      {
        title: "Who can apply?",
        text: `U.S. Citizens or permanent residents ages ${minAge}-${maxAge} are welcome to apply.`
      },
      {
        title: "Extra benefits",
        text: "Instant decision on your coverage that decreases monthly at a predetermined amortization schedule. Guaranteed level premiums for the term of coverage."
      }
    ],
    hideNeedsAnalysis: true,
    hideVideoLink: true,
  }
}

ProductSpecificationsData.propTypes = {
  minAgeDays: PropTypes.number.isRequired,
  maxAge: PropTypes.number.isRequired,
  minCoverageAmount: PropTypes.number.isRequired,
  maxCoverageAmount: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Americo/ProductSpecificationsData.js